module.exports = __webpack_public_path__ + "img/Picture12.3ec35a07.png";